import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { ConfigService } from './shared/config.service';
import { MainComponent } from './main/main.component';
import { MainModule } from './main/main.module';
import { ResultsComponent } from './results/results.component';
import {IntermediateEasyclaimTLComponent} from './intermediate-easyclaim-tl/intermediate-easyclaim-tl.component';

const routes: Routes = [
  {
    path: 'welcome',
    component: WelcomeComponent,
//    resolve: { config: ConfigService }
  },
  {
    path: 'intermediate-easyclaim-tl',
    component: IntermediateEasyclaimTLComponent
  },
  {
    path: 'main',
    component: MainComponent,
    loadChildren: () => import('./main/main.module').then(m => m.MainModule)
  },
  {
    path: 'case',
    component: ResultsComponent,
    resolve: { config: ConfigService },
    loadChildren: () => import('./results/results.module').then(m => m.ResultsModule)
  },
  {
    path: '**',
    redirectTo: 'welcome',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
